/**
 * One-shot guard for the access-denied (403) recovery reload.
 *
 * When the server-side-selected advertiser/account is inaccessible, every data
 * query 403s. We recover by reloading the page (the backend self-corrects the
 * selection on the next bootstrap). The guard lives in `sessionStorage` so it
 * survives that reload: if a request still 403s afterwards, we must NOT reload
 * again, otherwise the page reloads forever. It's cleared on the next successful
 * response, when the app is healthy again.
 */
const ACCESS_DENIED_RELOAD_GUARD_KEY = 'accessDeniedReloaded';

/** Delay before reloading so the warning snackbar is readable first. */
export const ACCESS_DENIED_RELOAD_DELAY_MS = 3000;

export const hasReloadedForAccessDenied = (): boolean =>
  sessionStorage.getItem(ACCESS_DENIED_RELOAD_GUARD_KEY) !== null;

export const markReloadedForAccessDenied = (): void => {
  sessionStorage.setItem(ACCESS_DENIED_RELOAD_GUARD_KEY, '1');
};

export const clearAccessDeniedReloadGuard = (): void => {
  sessionStorage.removeItem(ACCESS_DENIED_RELOAD_GUARD_KEY);
};
